module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
 var uS = require('UserService.js').default; 
    ; __append("\r\n<!-- 3 column layout -->\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn(dashboardTitle))
    ; __append("</h1>\r\n        </div>\r\n    </div> \r\n\r\n    <ol class=\"breadcrumb\">\r\n        <li><a href=\"#\" id=\"goToReports\">Reports</a></li>\r\n        <li><a href=\"#\" id=\"goToEditReport\">Edit Report</a></li>\r\n        <li class=\"active\">")
    ; __append(escapeFn( currentReportName ))
    ; __append("</li>\r\n    </ol>\r\n</div>\r\n<div class=\"row col-lg-12\" style=\"margin-left: 0;padding-left: 10px;\">\r\n    <div class=\"col-sm-12 col-lg-4\" style=\"height: 395px;\">\r\n        <div class=\"block\">\r\n            <h2>Details</h2> \r\n            <div class=\"row nopadding\">\r\n                <div class=\"col-sm-6\">\r\n                    <span>Owner</span>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <span>")
    ; __append(escapeFn( ownerName ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row nopadding\">\r\n                <div class=\"col-sm-6\">\r\n                    <span>Date Published</span>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <span>")
    ; __append(escapeFn( lastUpdate ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row nopadding\">\r\n                <div class=\"col-sm-6\">\r\n                    <span>Published Version</span>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <span>")
    ; __append(escapeFn( latestVersion ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row col-lg-12\" style=\"margin-left: 0;padding-left: 10px;\">\r\n        <div class=\"col-sm-12 col-lg-4\">\r\n            <div class=\"block\">\r\n                <h2></h2>  \r\n            </div>\r\n        </div>\r\n    </div>    \r\n\r\n    <div class=\"row\" id=\"reportActionSection\">\r\n        <div class=\"col-sm-12\">\r\n            <button id=\"viewReport\" class=\"btn btn-primary hvr-glow\">View</button>\r\n        </div>       \r\n    </div>\r\n</div>")
  }
  return __output;

}